<template>
    <v-app>
        <sidebar v-if="logged" :drawer="drawer" @update-drawer="drawer = !drawer" @close-drawer="detectEvent" />
        <navbar v-if="logged" :drawer="drawer" @update-drawer="drawer = !drawer" @close-drawer="detectEvent" />
        <v-main> <router-view class="container" /> </v-main>
    </v-app>
</template>

<script>
import { mapState } from 'vuex'
import navbar from './components/navigation/navbar'
import sidebar from './components/navigation/sidebar'

export default {
    name: 'App',
    components: {
        navbar,
        sidebar
    },
    computed:{
        ...mapState('user', {
            logged: state => state.logged
        })
    },
    data() {
        return {
            drawer: true,
            chartWidth: 0,
        }
    },
    methods: {
        detectEvent(value){
            this.drawer = value
            let name = this.$vuetify.breakpoint.name
            if(this.drawer){
                switch (name) {
                    case 'xs': this.chartWidth=350; break;
                    case 'sm': this.chartWidth=350; break;
                    case 'md': this.chartWidth=350; break;
                    case 'lg': this.chartWidth=350; break;
                    default: this.chartWidth=350; break;
                }
            }else{
                switch (name) {
                    case 'xs': this.chartWidth=400; break;
                    case 'sm': this.chartWidth=400; break;
                    case 'md': this.chartWidth=400; break;
                    case 'lg': this.chartWidth=400; break;
                    default: this.chartWidth=400; break;
                }
            }
        }
    },
};
</script>

<style scope>
.container{
    background-color: var(--v-background-base);
    min-height: 100%;
    min-width: 100%;
}

.v-card{
    border-radius: 10px !important;
}
</style>